// Import everything from autoload
import './autoload/dev.js'; import './autoload/form.js'; import './autoload/smoothScroll.js'; import './autoload/sticky.js'; import './autoload/toggle.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
});

// Load Events
document.addEventListener('DOMContentLoaded', () => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js